module.exports = __webpack_public_path__ + "media/images/prizeTeaserDeco-a1c9b19e4c929f12245be6cb7dbffc96.png";